import React, { useEffect, useState, useRef } from 'react';
import styles from "./fillout.module.css";
import InnerHeader from '../../etc/innerheader';
import { FilloutStandardEmbed } from "@fillout/react";
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const FillOutEmbed: React.FC<any> = (props) => {

    const topDivRef = useRef<any>(null);
    const [statusDivHeight, setStatusDivHeight] = useState(0);
    const history = useHistory();
    const location: any = useLocation();

    useEffect(() => {

        if (!topDivRef || !topDivRef.current) {
            return;
        }

        const calculateStatusDivHeight = () => {

            setTimeout(() => {

                if (!topDivRef || !topDivRef.current) {
                    return;
                }

                const totalHeight = window.innerHeight;
                const topDivHeight = topDivRef.current.offsetHeight;

                const statusDivHeight = totalHeight - topDivHeight - 5;

                setStatusDivHeight(statusDivHeight);

            }, 20);

        }

        calculateStatusDivHeight();

        window.addEventListener("resize", () => calculateStatusDivHeight());

        return () => window.removeEventListener("resize", () => calculateStatusDivHeight());

    }, [topDivRef]);

    useEffect(() => {

        if(!location.state || !location.state.userId || !location.state.filloutId) {
            history.push("/mobiledashboard");
        }

    }, []);

    useEffect(() => {

        const script = document.createElement("script");
        script.src = "https://server.fillout.com/embed/v1/";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }

    }, []);


    return (
        <div style={{
            width: "100%",
        }}>
            <div ref={topDivRef}>
                <InnerHeader
                    title={location.state && location.state.title ? location.state.title : ""}
                    handleClickBackBtnFunc={() => {
                        history.push({
                            pathname: location.state.returnUrl || "/mobiledashboard/mycoaching",
                            state: {
                                nextCurrentStatus: location.state.nextCurrentStatus || 0,
                                deepResearchFinish: location.state.deepResearchFinish || false,
                                weekScheduleFinish: location.state.weekScheduleFinish || false,
                                chatRoomId: location.state.chatRoomId || undefined,
                            }
                        });
                    }}
                />
            </div>
            <div style={{
                height: `${statusDivHeight}px`,
                width: "100%",
            }}>
                {
                    (location.state && location.state.userId && location.state.filloutId)
                        ?
                        <FilloutStandardEmbed
                            filloutId={location.state.filloutId}
                            onSubmit={() => {
                                history.push({
                                    pathname : location.state.returnUrl || "/mobiledashboard/mycoaching",
                                    state : {
                                        nextCurrentStatus : location.state.nextCurrentStatus || 0,
                                        deepResearchFinish : location.state.deepResearchFinish || false,
                                        weekScheduleFinish : location.state.weekScheduleFinish || false,
                                        chatRoomId : location.state.chatRoomId || undefined,
                                    }
                                });
                            }}
                            parameters={{
                                userId: location.state.userId,
                                _t : location.state._t ? location.state._t : undefined,
                                feedbackMessageId : location.state.feedbackMessageId ? location.state.feedbackMessageId : undefined,
                            }}
                        />
                        :
                        "로그인 후 작성해주세요."
                }

            </div>
        </div>

    )
}

export default FillOutEmbed;